module.exports = __webpack_public_path__ + "static/media/article_bg.b2a24e0a.jpg";